
export const getParentsOrg = content => content
  .parents.find( parent => parent.__typename === 'Organization' );

export const getParentsProperty = content => content
  .parents.find( parent => parent.__typename === 'Property' );

export const getParentsCollection = content => content
  .parents.find( parent => parent.__typename === 'Collection' );
